import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="/logo.png"
                alt="SEELAKARIYMMAN IRRIGATION Logo"
                className="h-14 w-14 object-contain"
              />
              <h3 className="text-xl md:text-2xl font-bold bg-gradient-to-r from-green-600 via-green-500 to-emerald-600 bg-clip-text text-transparent">
                SEELAKARIYMMAN IRRIGATION
              </h3>
            </div>
            <p className="body-medium mb-4" style={{ color: 'var(--text-secondary)' }}>
              Trusted agriculture and irrigation solutions provider in Dharmapuri, Tamil Nadu.
              We specialize in modern water-saving irrigation systems.
            </p>
            <div className="flex items-start space-x-2 mb-2">
              <MapPin className="w-5 h-5 mt-1 flex-shrink-0" style={{ color: 'var(--accent-text)' }} />
              <div>
                <a
                  href="https://maps.app.goo.gl/Berr6sUCjMETggov8?g_st=awb"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="body-small hover:text-green-600 transition-colors underline"
                >
                  5/202A, Vadakku Theru Kottavur, Adiyamankottai,<br />
                  Nallampalli, Dharmapuri, Tamil Nadu - 636807
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-3 mb-4" style={{ fontSize: '1.125rem' }}>Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="body-small hover:text-green-600 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="body-small hover:text-green-600 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/products" className="body-small hover:text-green-600 transition-colors">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/contact" className="body-small hover:text-green-600 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="heading-3 mb-4" style={{ fontSize: '1.125rem' }}>Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2">
                <Phone className="w-4 h-4" style={{ color: 'var(--accent-text)' }} />
                <a href="tel:6382799541" className="body-small hover:text-green-600 transition-colors">
                  6382799541
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="w-4 h-4" style={{ color: 'var(--accent-text)' }} />
                <a href="tel:7904369704" className="body-small hover:text-green-600 transition-colors">
                  7904369704
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="w-4 h-4" style={{ color: 'var(--accent-text)' }} />
                <a href="mailto:seelakariymman@gmail.com" className="body-small hover:text-green-600 transition-colors">
                  seelakariymman@gmail.com
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Clock className="w-4 h-4" style={{ color: 'var(--accent-text)' }} />
                <span className="body-small">Mon-Sat: 9 AM - 7 PM</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-8 text-center">
          <p className="body-small" style={{ color: 'var(--text-muted)' }}>
            © {new Date().getFullYear()} SEELAKARIYMMAN IRRIGATION. All rights reserved. | Owner: Govindaraju K
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;